import useQuery from "./useQuery";

export default function useXsollaTokenOverrideId() {
	const query = useQuery();
	const xsollaTokenOverrideId = query.get("xsollaTokenOverrideId") || "";
	return { xsollaTokenOverrideId };
}
